import { FC } from "react";
import styles from "./Services.module.scss";
import { services } from "../../constants/services";
import { normalPrice } from "../../utils/formatPrice";

interface ServicesProps {
  classess?: string;
}

const Services: FC<ServicesProps> = ({ classess }) => {
  return (
    <div className={styles.Services}>
      <h2>Список предостовляемыхуслуг:</h2>

      <p className={styles.symbols}>* - Cтоимость индивидуальна</p>

      <ul>
        {services.map(({ name, price }, i) => (
          <li key={i.toString()}>
            <p>{name}</p>
            {!isNaN(+price) && normalPrice(price.toString()) + "₽"}
            {isNaN(+price) && (
              <div title="Cтоимость индивидуальна " className={styles.symbol}>
                *
              </div>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Services;
